import { openModal, closeModal } from '../lib/modal.js';

// Replaces window.confirm(text) — that dialog is silently unreliable in iOS standalone mode
// (added-to-Home-Screen), which is exactly how "Удалить" buttons could end up deleting things
// without ever showing a real prompt. onYes runs only after an explicit tap on the button.
// `danger` defaults to true (red button) since most callers really are confirming a delete —
// pass false for a non-destructive confirmation (e.g. "leave unsaved changes and navigate
// away") so the button doesn't read as a scary delete warning it isn't.
export function showConfirm(text, onYes, okLabel, danger = true) {
  document.getElementById('confirmDialogText').textContent = text;
  const btn = document.getElementById('confirmDialogOkBtn');
  btn.textContent = okLabel || 'Удалить';
  btn.classList.toggle('btn-danger', danger);
  btn.classList.toggle('btn-primary', !danger);
  const freshBtn = btn.cloneNode(true); // strip any previously-attached handler before rebinding
  btn.parentNode.replaceChild(freshBtn, btn);
  freshBtn.onclick = () => { closeModal('shConfirmDialog'); onYes(); };
  openModal('shConfirmDialog');
}
